module.exports = __webpack_public_path__ + "3e28da7cb59f2f78b268bc4d81734c2a.pdf";